var help_center_search_ajax = null;
var search_keyword = '';
var prefilled_callus = false;
var help_center_ajax = null;
var email_checking_help_ajax = null;
var success_page_ajax = null;
var regex_email_pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
var help_center_fields_md = null;
var help_center_fields_sm = null;
var details_entered = [];
// the view an article was opened from (openHelpArticle(): "#hc-home" or "#hc-all-articles"), shown again by its Back link
var help_center_article_from_view = null;
// the login modal's place in the page while it is a sheet over the panel, and whether a sign-in reloads the panel (desktop:
// the signed-out home's Log in, COOL 394)
var help_center_auth_modal_home = null;
var help_center_login_reload = false;

jQuery("document").ready(function() {
    let help_center_page = '';
    let help_center_article_on_open = null; // a link's data-help-article: the article the panel opens on once its list has loaded
    let textUsSms = '';

    changeFormsSizeAccordingToWidth();
    window.addEventListener("resize", changeFormsSizeAccordingToWidth);

    if ( checkContactRestricted() ){
        removeContactTopLinksAndReplace();
    }

    $(document).keydown(function(event) {
      if (event.keyCode == 27) {
       if ( $("#help-center-right-side .c-modal-portal.open").length ){ // a sheet over the panel: Esc closes the sheet
        closeHelpCentreSheets();
       }else if ( $("#help-center-right-side").hasClass("open") ){
        $(".help-center-tint").click();
       }
      }
    });

    $(document).on("keyup",'.app-html .form-input-field[required]:visible', function() {

        var empty = false;
        $('.app-html .form-input-field[required]:visible').each(function() {
            if ($(this).val() == '') {
                empty = true;
            }
        });

        if (empty) {
            $('.help-center-contact-btn').attr('disabled', 'disabled');
        } else {
            if ( help_center_el === 'text-us' || regex_email_pattern.test($("#_elev_io #email_address").val()) !== false || $(".app-html .card-details").not(".d-none").length || $(".email-address-validation-message:visible:contains('reach you by phone')").length ){
                $('.help-center-contact-btn').removeAttr('disabled');
            }
        }

    });

    $(document).on("change",'.customer-field-value-changed', function () {
        var field_name = $(this).attr('name');
        var field_value = $(this).val();
        if (!field_value) {
            return;
        }
        if (field_name === 'customer_email') {
            jQuery("#talk-to-us-area #email_address").removeClass('non-verified');
            isvalidemail = regex_email_pattern.test(field_value);
            if (!isvalidemail) {
                $("#talk-to-us-area .email-address-validation-message").html('Please enter valid email address');
                $("#talk-to-us-area .email-address-validation-message").removeClass('danger').show();
                jQuery("#talk-to-us-area #email_address").addClass('danger');
                return;
            } else if (
                !didYouMeanEmail
                || (didYouMeanEmail && didYouMeanEmail !== jQuery('#email_address').val() && !keepWrittenEmail)
            ) {
                if ( !prefilled_callus ){
                    validateEmailFromAPI();
                }else{
                    email_flag = true;
                }
                return; // Save email only after verified
            }
        }

    });

  function validateEmailFromAPI() {

        var emailAddress = jQuery('#email_address').val();
        if (didYouMeanEmail && didYouMeanEmail === emailAddress) {
            return;
        }

        if ( typeof link_color === 'undefined' ){
            link_color = 'blue';
        }

        $("#talk-to-us-area .email-address-input").find(".loader").show();
        email_flag = false;
        email_checking_help_ajax = jQuery.ajax({
            type: "post",
            url: tm_ajax_url,
            dataType: "json",
            data: {
                "action": "validate_email_address",
                "email": emailAddress,
            },
            success(returnJSON) {

                var forceSave = true;
                if (returnJSON.data && returnJSON.data.did_you_mean) {
                    didYouMeanEmail = returnJSON.data.did_you_mean;

                    var suggestHTML = 'Did you mean <strong>' + didYouMeanEmail + '?</strong> <br />' + ' <a id="apply-did-u-mean-email" class="' + link_color + '" href="javascript:void(0)">Apply Change</a>';
                    if (returnJSON.data.smtp_check || returnJSON.data.mx_found) {
                        suggestHTML += ' or <a id="keep-written-email"  class="' + link_color + '"  href="javascript:void(0)">Keep Existing</a>';
                    }
                    jQuery("#talk-to-us-area .email-address-validation-message").html(suggestHTML);
                    jQuery("#talk-to-us-area .email-address-validation-message").removeClass('danger').show();
                    jQuery('#talk-to-us-area #email_address').addClass('danger');
                    jQuery('#talk-to-us-area #email_address').addClass('non-verified');
                    //jQuery(".help-center-contact-btn").attr("disabled", true);
                    jQuery(window.parent).scrollTop(0);
                    forceSave = false;
                    email_flag = false;
                }

                if ( forceSave ) {
                    // email confirmation line
                    updateEmailConfirmationLine(true);

                }

                $("#talk-to-us-area .email-address-input").find(".loader").hide();
            }
        })
    }

    jQuery('body').delegate('#apply-did-u-mean-email', 'click', function () {
        if (didYouMeanEmail) {
            jQuery('#email_address').val(didYouMeanEmail);
            jQuery('#email_address').trigger('change');
            updateEmailConfirmationLine();
        }
    });

    jQuery('body').delegate('#keep-written-email', 'click', function () {
        keepWrittenEmail = true;
        jQuery('#email_address').trigger('change');
        updateEmailConfirmationLine(true);
    });

    $(document).on('input', '#email_address', function () {
        keepWrittenEmail = false;
        updateEmailConfirmationLine();
    });

    $(document).on("keypress keydown keyup",'#_elev_io #form-first-name, #_elev_io #phone, #_elev_io #email_address', function () {
        if ( $("#_elev_io #booking-id-edit-btn").is(":visible") ){

            let tmPhoneElForHelpCenter = TmPhoneEl.instance(helpCenterPhoneIdentifier);
            // no phone field (Text Us; fieldsCheck() fires keyup on the other fields): the phone counts as unchanged
            let currentPhoneValue = tmPhoneElForHelpCenter ? tmPhoneElForHelpCenter.getNumber() : details_entered.phone_number;
            if (
                $("#_elev_io #form-first-name").val() !== details_entered.name
                || currentPhoneValue !== details_entered.phone_number
                //|| $("#_elev_io #phone").val() !== details_entered.phone_number
                || $("#_elev_io #email_address").val() !== details_entered.email_address
            ){
                $("#form-booking-id").removeAttr("disabled").val('').addClass("empty");
                $(".help-center-contact-btn span").text("Lookup Booking");
                $(".booking-actions-el, .booking-id-not-found, .booking-id-found").addClass("hidden");
                $("#main-step-footer").show();
                $("#main-step-footer #request-callback-btn").show().attr("disabled","disabled");
                $("#main-step-footer #request-callback-btn .loader").hide();
                $("#cancellation-wrapper").empty();
                $("#_elev_io #booking-id-edit-btn").hide();
            }
        }
    });

    function updateEmailConfirmationLine(forceSuccess = false) {
        var emailVal = jQuery('#email_address').val();
        if (emailVal && regex_email_pattern.test(emailVal)) {
            if (
                (didYouMeanEmail && didYouMeanEmail === emailVal)
                || forceSuccess
            ) {

                if ( !prefilled_callus ){
                    jQuery("#talk-to-us-area .email-address-validation-message").html('If we can\'t reach you by phone we\'ll email <br /><strong style="color: green">' + emailVal + '</strong>');
                }else{
                    //jQuery("#talk-to-us-area .email-address-validation-message").html('');
                }

            } else {
                jQuery("#talk-to-us-area .email-address-validation-message").html('If we can\'t reach you by phone we\'ll email <br /><strong>' + emailVal + '</strong>');
            }
            prefilled_callus = false;
            email_flag = true;
            //jQuery(".help-center-contact-btn").attr("disabled", false);
            jQuery("#talk-to-us-area .email-address-validation-message").removeClass('danger').show();
            jQuery("#talk-to-us-area #email_address").removeClass('danger non-verified');
        } else {
            jQuery("#talk-to-us-area .email-address-validation-message").html('');
            //jQuery("#talk-to-us-area #email_address").addClass('danger');
        }

        $("#talk-to-us-area .message_field:visible").change();

    }

    $(document).on("click", ".help-center-link", function(e){
        e.preventDefault();
        let helpCenterLink = $(this);
        let openModuleAllow = true;

        if ( helpCenterLink.data("help-center") === 'text-us' && helpCenterLink.attr("data-sms") ){
            textUsSms = helpCenterLink.attr("data-sms");
        }

        if ( helpCenterLink.data("help-center") === 'manage-booking' ){
            openModuleAllow = true;
        }

        // the signed-in home's Text Message and Live Chat (data-hc-contact-form, includes/categories.php) open their form
        // first, its Send us a Text / Start Chatting acting (#send-text-btn, #live-chat-btn; Peter, COOL 383)
        const contactForm = typeof helpCenterLink.data("hc-contact-form") !== 'undefined';

        if ( !contactForm && helpCenterLink.data("help-center") === 'text-us' && tmVisitorStore.getDetail('name').length > 0 ) {
            openModuleAllow = false;
            textWhenWeHaveName();
        }

        if( !contactForm && helpCenterLink.data("help-center") === 'live-chat') {
            openModuleAllow = false;
            coolEvents.triggerChatOpen();
        }

        if ( openModuleAllow ){

            // data-help-article="<help post ID>": the panel opens straight on that article, loaded as a click in its list
            // loads one, so its Back link returns to the list (the booking view's "Learn more about cancellations")
            const helpArticleId = parseInt(helpCenterLink.data("help-article"), 10) || null;
            if ( helpArticleId && $("#help-center-right-side").hasClass("open") && $("#article-section").length ){
                openHelpArticle(helpArticleId);
                return;
            }
            help_center_article_on_open = helpArticleId;

            if ( typeof helpCenterLink.data("sidebar") === 'undefined' ){
                $("#load-wrapper").remove();
            }else{
                jQuery(".hc-faq__categories-title, [data-type='category'], [data-type='suggestions'], [data-type='search'], #hc-home").hide(); // #hc-home: the HOME's next trip and buttons too (COOL 297)
            }

            $("#help-center-right-side .loader").show();

            if ( typeof helpCenterLink.data("help-center") !== 'undefined' && $("#help-center-right-side").hasClass("open") ){

                var data = {
                    'action': 'help_center',
                    'h'     : 'open',
                    'o'     : helpCenterLink.data("help-center"),
                    'c'     : checkContactRestricted(),
                };
                if ( helpCenterPreviewFlag() ){ data.next = 'yes'; }
                if ( helpCenterOnBookingPage() ){ data.nb = 1; } // no Upcoming booking on a booking page (includes/upcoming-booking.php)

                if ( typeof helpCenterLink.data("accordion-expand") !== 'undefined' ){
                    data['a'] = '1';
                }

                help_center_ajax = jQuery.post(ajaxurl, data, function(response) {
                    help_center_page = 'categories';
                    if ( typeof helpCenterLink.data("sidebar") !== 'undefined' ){
                        $("#load-wrapper").remove();
                    }
                    $("#help-center-right-side").append( response );
                    $("#help-center-right-side .loader").hide();
                    $("#main-container").addClass("hideOnMobile");
                });

                changeFormsSizeAccordingToWidth();

            }else{

                if ( typeof helpCenterLink.data("accordion-expand") !== 'undefined' ){
                    $("#help-center-right-side").trigger("onHelpCenterInit", [helpCenterLink.data("help-center"), helpCenterLink.data("accordion-expand")]);
                }else{
                    $("#help-center-right-side").trigger("onHelpCenterInit", [helpCenterLink.data("help-center"), null ]);
                }
            }
        }


    });

    function textWhenWeHaveName(){
        if (tmVisitorStore.isSalesDepartment()) {
            sendText( "I'd like more info[PRODUCT/PAGE]", false );
        }
        else {
            sendText( "I have a question about my booking ", false );
        }
    }

    // the number of the Text Us link clicked last, else the top bar's (which is not there when the top bar is off). Each one
    // is cut to its digits first: a page cached before #621 prints [TEXT-US-LINK] with no digits (data-sms="<?=$sms?>"),
    // and then the top bar's number is used, as before
    function sendText( txtBody = '', name = false ){
        txtBody = '[[BRAND]] ' + txtBody;
        if ( name ){
            txtBody = txtBody +  " [NAME]";
        }
        txtBody = fixShortCode( txtBody );

        const smsNumber = [ textUsSms, $(".sms_info a").attr("data-sms") ].map(function( s ){ return String( s || '' ).replace(/[^\d]/g, ""); }).find(Boolean) || '';
        if ( !smsNumber ){
            return;
        }
        window.open("sms:" + "+1" + smsNumber + "?&body=" + encodeURIComponent( txtBody ), '_self');
    }

    $("#help-center-right-side").on('onHelpCenterInit', function( event, type, accordion_expand ) {

        restartSearch();
        $(this).toggleClass("close");
        $(this).toggleClass("open");
        // $(this).toggleClass("open");
        if ( $(this).hasClass("close") ){
            help_center_article_on_open = null; // closing: no article waits for the next open
        }
    $("#categories-section").show();
        if ( $(this).hasClass("close") && typeof help_center_ajax !== '' && typeof help_center_ajax !== 'undefined' && help_center_ajax !== null ){
            help_center_ajax.abort();
            help_center_article_on_open = null;
            //$("#help-center-right-side").children().remove();
            //$("section[data-view='categories']").remove();
        }else{
            $("#help-center-right-side .loader").show();
            $("#article-section").children().remove();
            jQuery(".hc-faq__categories-title, [data-type='category'] , [data-type='suggestions'], [data-type='search']").show();

            if ( true ){ // $(".helpCentreShell").length == 0
                var data = {
                    'action': 'help_center',
                    'h'     : 'open',
                    'c'     : checkContactRestricted(),
                };
                if ( helpCenterPreviewFlag() ){ data.next = 'yes'; }
                if ( helpCenterOnBookingPage() ){ data.nb = 1; }

                if ( typeof type !== 'undefined' ){
                    data.o = type;
                }

                if ( typeof accordion_expand !== 'undefined' ){
                    data.a = accordion_expand;
                }

                help_center_ajax = jQuery.post(ajaxurl, data, function(response) {
                    help_center_page = 'categories';
                    $("#help-center-right-side").append( response );
                    $("#help-center-right-side .loader").hide();
                    $("#main-container").addClass("hideOnMobile");
                    fixWidth();
                    if ( help_center_article_on_open ){
                        const articleId = help_center_article_on_open;
                        help_center_article_on_open = null;
                        openHelpArticle(articleId);
                    }
                });
            }else{
                $("#help-center-right-side .loader").hide();
            }
        }
    });

   $(".mobile-help-link").on("click", evt => {
    evt.preventDefault();
    $("#help-center-right-side").trigger("onHelpCenterInit");
   });

    $(".c-avatar-dropdown-item-link.help-center-link").on("click", function(){
        $("#help-center-right-side").trigger("onHelpCenterInit");
    });

    jQuery(document).on("click", ".category-title", function(e){

        jQuery(this).next('.articles-list').toggleClass("hide");
        jQuery(this).find('.plus-minus-icon').toggleClass("hide");
        fixWidth();
    });

    jQuery(document).on("click", ".helpCentreShellMainInner .hClickable, .help-center-tint, .articles-list .help-center-link[data-help-center='live-chat']:not([data-hc-contact-form])", function(e){
        help_center_article_on_open = null; // closed (the X, the tint, Esc): no article waits for the next open
        closeHelpCentreSheets(); // before the panel's markup goes: a sheet open on it holds the page's scroll lock (modal.js)
        restartSearch();
        $("#main-container").removeClass("hideOnMobile");
        $("#help-center-right-side .loader").hide().removeClass("hc-skeleton--article");
        $("#help-center-right-side").toggleClass("close");
        $("#help-center-right-side").removeClass("open");
        $("#load-wrapper").remove();

        if ( typeof help_center_ajax !== '' && typeof help_center_ajax !== 'undefined' && help_center_ajax !== null ){
            help_center_ajax.abort();
        }

        if ( typeof email_checking_help_ajax !== '' && typeof email_checking_help_ajax !== 'undefined' && email_checking_help_ajax !== null ){
            email_checking_help_ajax.abort();
        }

        if ( typeof success_page_ajax !== '' && typeof success_page_ajax !== 'undefined' && success_page_ajax !== null ){
            success_page_ajax.abort();
        }

    });

    jQuery(document).on("click", ".hc-faq__back-button", function(){
        if ( $(this).is("[data-hc-home-back]") ){
            return; // "See all articles"' own Back (below): the home, not an article's list
        }
        $("#article-section").children().remove();
        jQuery("#categories-section, .hc-faq__categories-title, [data-type='category'], [data-type='suggestions'], [data-type='search']").show();
        if ( help_center_article_from_view ){
            $(help_center_article_from_view).show();
            help_center_article_from_view = null;
        }
        if ( $("#talk-to-us-area").length > 0 ){
            $("#talk-to-us-area").show();
            $("[data-slot-name='back_button']").show();
        }
        restartSearch();
    });

    // Shows one help article in the open panel, over its list (the Back link returns to the list): a click in the list,
    // or a link's data-help-article (above). faqIndex: one question of the next trip's FAQ instead (data-faq, its place in
    // help_center_booking_faqs(); COOL 380)
    function openHelpArticle(articleId, faqIndex){
        // the HOME (its next trip and buttons) or the "See all articles" view goes with the list, and Back brings back the
        // one that was showing (COOL 297)
        help_center_article_from_view = $("#hc-all-articles").is(":visible") ? "#hc-all-articles" : ( $("#hc-home").is(":visible") ? "#hc-home" : null );
        jQuery("#hc-home, #hc-all-articles").hide();
        jQuery(".hc-faq__categories-title, [data-type='category'], [data-type='suggestions'], [data-type='search'], #talk-to-us-area, [data-slot-name='back_button']").hide();
        jQuery("#help-center-right-side .loader").addClass("hc-skeleton--article").show(); // the article's skeleton (footer.php)

        var data = {
            'action': 'help_center',
            'h'     : 'article',
            'id'    : articleId,
            'c'     : checkContactRestricted(),
        };
        if ( typeof faqIndex !== 'undefined' ){
            data.h = 'booking-faq';
            data.i = faqIndex;
        }

        help_center_ajax = jQuery.post(ajaxurl, data, function(response) {
            help_center_page = 'article';
            jQuery("#help-center-right-side .loader").hide().removeClass("hc-skeleton--article");
            $("#article-section").children().remove();
            $("#article-section").append( response );
        });
    }

    jQuery(document).on("click", "._tm_articlelink_title", function(){

        if ( !$(this).hasClass("no-article") ){
            openHelpArticle($(this).data("id"), $(this).data("faq"));
        }
    });

    // HOME's "See all articles" (templates/categories.php): the category accordions in place of the home, and their Back
    // button the home again (an article opened from either returns to it: the article's Back shows the section as it was).
    // The home's search field goes with it, under "Help Articles", and back: moved, not copied, so its id and the
    // document-level handlers stay (Peter, COOL 389). The view itself (templates/all-articles.php) is asked for the first
    // time, under the article's skeleton, not rendered hidden on every open (review of PR #697)
    let help_center_all_articles_ajax = null;
    let help_center_all_articles_for = null; // the #hc-all-articles it fills
    jQuery(document).on("click", "[data-hc-all-articles]", function(){
        const faqTab = $(this).is("[data-hc-faq-tab]");
        const $view = $("#hc-all-articles");
        if ( !$view.children().length ){
            if ( help_center_all_articles_ajax ){
                if ( help_center_all_articles_for === $view[0] ){
                    return; // already on its way
                }
                help_center_all_articles_ajax.abort(); // a panel since reloaded asked for it
            }
            help_center_all_articles_for = $view[0];
            $("#hc-home").hide();
            jQuery("#help-center-right-side .loader").addClass("hc-skeleton--article").show();
            var data = {
                'action': 'help_center',
                'h'     : 'all-articles',
                'c'     : checkContactRestricted(),
            };
            if ( helpCenterOnBookingPage() ){ data.nb = 1; }
            help_center_all_articles_ajax = jQuery.post(ajaxurl, data, function(response){
                if ( $view[0].isConnected ){ // not a panel since reloaded (closed and opened again, a form's Back)
                    $view.html(response);
                    helpCenterShowAllArticles(faqTab);
                }
            }).fail(function(){
                if ( $view[0].isConnected ){
                    $("#hc-home").show(); // the home again; the next click asks again
                }
            }).always(function(){
                if ( help_center_all_articles_for === $view[0] ){
                    help_center_all_articles_ajax = null;
                    help_center_all_articles_for = null;
                }
                if ( $view[0].isConnected ){
                    jQuery("#help-center-right-side .loader").hide().removeClass("hc-skeleton--article");
                }
            });
            return;
        }
        helpCenterShowAllArticles(faqTab);
    });

    // the view in the home's place, the home's search field in its slot; the FAQ home's "View all FAQ" opens on the
    // Activity FAQ tab (COOL 395)
    function helpCenterShowAllArticles(faqTab){
        jQuery('[data-hc-search-home] > *').appendTo('[data-hc-search-slot]');
        restartSearch();
        $("#hc-home").hide();
        $("#hc-all-articles").show();
        $(".categories-outer").scrollTop(0);
        var activityTab = $(".hc-faq-tabs .c-tabs-item").first();
        if ( faqTab && !activityTab.hasClass("c-tabs-item-active") ){
            activityTab.trigger("click");
        }
    }

    jQuery(document).on("click", "[data-hc-home-back]", function(){
        jQuery('[data-hc-search-slot] > *').appendTo('[data-hc-search-home]');
        restartSearch();
        $(".hc-activity-faq .c-picker-search input").val("").trigger("input"); // every question again next time (COOL 395)
        $("#hc-all-articles").hide();
        $("#hc-home").show();
        $(".categories-outer").scrollTop(0);
    });

    jQuery(document).on("click", "._tm_close_search_icon_container", function(){
        restartSearch();
    });


    jQuery(document).on("keyup", "#_tm_io_placebo",  function(e) {
        const text_input = $(this);

        $("._tm_search_results").hide();
        $(".search_results_loader").hide();

        if ( help_center_search_ajax !== null ){
            help_center_search_ajax.abort();
        }

        if ( $(text_input).val().length > 0 ){
            $("._tm_search_results").show();
            $("._tm_close_search_icon_container").show();
            $("#search-for").text( '"' + $(text_input).val() + '"' )
        }else{
            $("._tm_close_search_icon_container").hide();
        }

        if ( search_keyword != $(text_input).val() ){
            $("._tm_search_results_content").css("opacity",0);
            $("#_tmn_io ._1dafq").css("opacity",1);
        }

        if ( $(text_input).val().length > 1  && e.which === 13 ){ // If enter pressed
            $(".search_results_loader").show();
            $("#_tmn_io ._1dafq, ._tm_search_results_content").css("opacity","0");

            var data = {
                'action': 'help_center',
                'h'     : 'search-article',
                's'     : $(text_input).val(),
                'c'     : checkContactRestricted(),
            };
            if ( helpCenterOnBookingPage() ){ data.nb = 1; } // and none on a booking's own page: the help articles only (review of PR #697)

            help_center_search_ajax = jQuery.post(ajaxurl, data, function(response) {
                search_keyword = $(text_input).val();
                $("._tm_search_results_content").remove();
                $("._tm_search_results").append(response);
                $("._tm_search_results_content").css("opacity","1");
                $(".search_results_loader").hide();

            });
        }
    });

    $(document).on("click",".removeLink", function(e){
        e.preventDefault();
    });

    // Back from the cancel or refund page: the browser can show this page as it was left (its back/forward cache), with
    // Start Cancellation / Request a Refund still spinning and "I'd like to" greyed; both work again (#672 review F25)
    let help_center_left_for_cancel_page = false;
    $(window).on("pageshow", function(e){
        if ( !help_center_left_for_cancel_page || !e.originalEvent || !e.originalEvent.persisted ){
            return;
        }
        help_center_left_for_cancel_page = false;
        $("#booking_actions").prop("disabled",false);
        $(".help-center-contact-btn").removeAttr("disabled").find(".loader").hide();
    });

    $(document).on("click","#request-callback-btn, #live-chat-btn:contains('Lookup Booking'), #live-chat-btn:contains('Request a Callback')", function(){
        const callback_btn = $(this);

        const name = $("#_elev_io #form-first-name").val();
        let tmPhoneElForHelpCenter = TmPhoneEl.instance(helpCenterPhoneIdentifier);
        const phone = tmPhoneElForHelpCenter.getNumber();
        //const phone = $("#_elev_io #phone").val();
        const email = $("#_elev_io #email_address").val();

        if ( typeof success_page_ajax !== '' && typeof success_page_ajax !== 'undefined' && success_page_ajax !== null ){
            success_page_ajax.abort();
        }

        callback_btn.attr("disabled", true);
        callback_btn.find(".loader").removeClass("hidden").css("display","inline");

        if ( jQuery.trim($(this).text()) === 'Start Cancellation' && $("#booking_actions").val() == 3 ){

            $("#booking_actions").prop("disabled",true);
            var data = {
                'action': 'help_center_cancellation_request_callback',
                'first': name,
                'email': email,
                'phone': phone,
                'booking_id': $("#form-booking-id").val(),
                'open': 'page', // the page's address as JSON (without it, help-center.php answers the old script's way)
                'l'     :  tmUtils.getAjaxRequestNonce(),
            }


            // the booking's cancel page, in this tab (Prashant, COOL 339): one cancel page everywhere; a refusal (not found,
            // too many tries) shows in the lookup's message box
            success_page_ajax = jQuery.post(ajaxurl, data, function(response) {
                try {
                    coolEvents.visitorProvidedDetails(name, email, phone);
                }
                catch(error) {}

                var resp = {};
                try {
                    resp = JSON.parse(response);
                }
                catch(error) {}

                if ( resp.url ){
                    help_center_left_for_cancel_page = true;
                    window.location.href = resp.url;
                    return;
                }
                $("#booking_actions").prop("disabled",false);
                callback_btn.removeAttr("disabled").find(".loader").hide();
                $(".booking-id-not-found > p").html( resp.request_box_message || 'Sorry, please refresh page and try again.' );
                $(".booking-id-not-found").removeClass("hidden");
            });
            return false;
        }

        // the Booking ID's lookup (helpCenterLookupBooking())
        if ( $(".step-footer button span").text() === 'Lookup Booking' ){
            helpCenterLookupBooking(callback_btn);
            return;
        }

        var message = $("#_elev_io .message_field:visible").val();
        const department_id = $("#_elev_io #how_can_we_help option:selected").data('id');
        var selectedType = $('#how_can_we_help option:selected').attr('data-calltype');
        var callType = $('#how_can_we_help').val();

        if ( selectedType === 'ExistingBooking' && $(".help-center-contact-btn span").text() === 'Request a Callback' ){
            selectedType = 'Support';
            callType = 'Assistance with an existing booking';
        }

        var data = {
            'action': 'help_center_request_callback',
            'calltype': selectedType,
            'calltype_description': callType,
            'first': name,
            'email': email,
            'phone': phone,
            'message': message,
            'l'     :  tmUtils.getAjaxRequestNonce(),
            'm'     :  JSON.stringify(tmVisitorStore.getTags())
        };

        if ( $('#how_can_we_help option:selected').attr('data-calltype') === 'ExistingBooking' && $(".help-center-contact-btn span").text() === 'Request a Callback' ){
            data.booking_id = $("#form-booking-id").val();
            data.booking_action = $("#booking_actions option:selected").text();
        }

        if ( typeof a_id !== 'undefined' ){
            data.a_id = a_id;
        }

        success_page_ajax = jQuery.post(ajaxurl, data, function(response) {
            try {
                coolEvents.visitorProvidedDetails(name, email, phone);
            }
            catch(error) {}

            if ( response.search("Sorry") === -1 ){
                //setZopimDataForChat( name, phone, email, message, department_id, false, false );
                //Cookies.set("tm-contact-restricted", "true", { expires: 1 });
                //removeContactTopLinksAndReplace();
            }

            $("#page-1").remove();
            $("#page-2").append(response);
            $("#page-2").removeClass("hidden");
        });

    });

    $(document).on("click", "#booking-id-edit-btn", function(){
        $("#form-booking-id").removeAttr("disabled").val('').addClass("empty").focus();
        $(".help-center-contact-btn span").text("Lookup Booking");
        $(".booking-actions-el, .booking-id-not-found, .booking-id-found").addClass("hidden");
        $("#main-step-footer").show();
        $("#main-step-footer #request-callback-btn").show().attr("disabled","disabled");
        $("#main-step-footer #request-callback-btn .loader").hide();
        $("#cancellation-wrapper").empty();
        $(this).hide();
    });

    $(document).on("click", "#send-text-btn", function(){
        if ( typeof success_page_ajax !== '' && typeof success_page_ajax !== 'undefined' && success_page_ajax !== null ){
            success_page_ajax.abort();
        }

        var sendTextButton = $(this);

        sendTextButton.attr("disabled", true);
        sendTextButton.find(".loader").removeClass("hidden").css("display","inline");

        var data = {
            'action': 'help_center_text_us_callback',
        };

        success_page_ajax = jQuery.post(ajaxurl, data, function(response) {
            const name = $("#_elev_io #form-first-name").val();
            let department_type = $("#_elev_io #how_can_we_help option:selected").data('calltype');
            tmVisitorStore.saveDetails(name);
            // Booking-related with the picker: "[Brand] I have a question about booking # C123456" (Peter, COOL 378/383)
            const pickedRef = $("#how_can_we_help").val() === 'Support (I have a booking)' ? String(hcBookingPickerSelected().attr("data-ref") || '') : '';
            if ( pickedRef !== '' ){
                sendText( "I have a question about booking # " + pickedRef, false );
            }else{
                sendText( $(".message_field:visible").val(), true );
            }
            $("#page-1").remove();
            $("#page-2").append(response);
            $("#page-2").removeClass("hidden");
        });
    })

    $(document).on("focus blur", "#_elev_io #form-first-name", function(e){
        if ( help_center_el === 'text-us' ){
            $("#how_can_we_help").trigger("change");
        }
    });

    $(document).on("click", ".customer-change", function(){
        jQuery(".card-details").toggleClass("d-none");
        jQuery(".change-inputs .d-none").toggleClass("d-none");
        jQuery('#form-first-name').focus();
    })

    $(document).on("click", "#request-a-refund-btn", function(){
        const callback_btn = $(this);
        callback_btn.attr("disabled", true);
        callback_btn.find(".loader").removeClass("hidden").css("display","inline");

        const name = $("#_elev_io #form-first-name").val();
        let tmPhoneElForHelpCenter = TmPhoneEl.instance(helpCenterPhoneIdentifier);
        const phone = tmPhoneElForHelpCenter.getNumber();
        //const phone = $("#_elev_io #phone").val();
        const email = $("#_elev_io #email_address").val();

        var data = {
            'action': 'help_center_refund_request_callback',
            'first': name,
            'email': email,
            'phone': phone,
            'booking_id': $("#form-booking-id").val(),
            'open': 'page', // the page's address as JSON (without it, help-center.php answers the old script's way)
            'l'     :  tmUtils.getAjaxRequestNonce(),
        };

        // the booking's refund page, in this tab, as Start Cancellation (Prashant, COOL 361); it asks for the sign-in. A
        // refusal (not found, too many tries) shows in the lookup's message box
        jQuery.post(ajaxurl, data, function(response) {
            var resp = {};
            try {
                resp = JSON.parse(response);
            }
            catch(error) {}

            if ( resp.url ){
                help_center_left_for_cancel_page = true; // the same back/forward reset as the cancel page
                window.location.href = resp.url;
                return;
            }
            callback_btn.removeAttr("disabled").find(".loader").hide();
            $(".booking-id-not-found > p").html( resp.request_box_message || 'Sorry, please refresh page and try again.' );
            $(".booking-id-not-found").removeClass("hidden");
        });
    });

    $(document).on("change","#booking_actions", function(){
        $("#cancellation-wrapper").children().remove();
        $("#main-step-footer").show();
        $(".help-center-contact-btn").attr("disabled","disabled").end().find(".loader").hide();
        if ( $(this).val().length > 0 ){
            $('.help-center-contact-btn').show().end().removeAttr('disabled').end().find(".loader").hide();
            if ( $(this).val() === "5" ){
                $(".message-request-element").addClass("hidden");
                $(".help-center-contact-btn").prop("id","request-a-refund-btn");
                $(".help-center-contact-btn").removeAttr("disabled");
                $('.help-center-contact-btn span').text("Request a Refund");
            }else if ( $(this).val() === "3" ){
                $(".message-request-element").addClass("hidden");
                $(".help-center-contact-btn").removeAttr("disabled");
                $(".help-center-contact-btn").prop("id","request-callback-btn");
                $('.help-center-contact-btn span').text("Start Cancellation");
            }else{
                $(".message-request-element").removeClass("hidden");
                $(".help-center-contact-btn").prop("id","request-callback-btn");
                $('.help-center-contact-btn span').text("Request a Callback");
            }
        }
    });

    $(document).on("change", "#how_can_we_help", function() {
        $("#your-details .card-details").removeClass("booking_margin");

        if ( $(this).val() === 'Support (I have a booking)' ){
            $("#your-details .card-details").addClass("booking_margin");
            $("#your-details #your-details-description").show();
        }
        else {
            $("#your-details #your-details-description").hide();
        }

        if ( $(this).val() !== '' ){
            $("#main-step-footer").show();
            //$("#request-callback-btn span").text( help_center_contact_button_text );

            $("#your-details").removeClass("hidden");

            const option = $(this).find("option:selected").data("option");
            const footer_message = $(this).find("option:selected").data("footer-message");

            if ( option === 'option-1-4' ){
                $(".help-center-contact-btn span").text("Lookup Booking");
            }

            $(".step-footer-message, .step-footer-message li").addClass("hidden");

            if ( footer_message ) {
                $(".step-footer-message").removeClass("hidden");
                $(".step-footer-message li").each( function ( element ){
                    let liClasses = $(this).prop("class").replace("hidden ","").split(" ");
                    if ( liClasses.includes( option ) ){
                        $(this).removeClass("hidden");
                    }
                });
            }

            $(".div-element").addClass("hidden");
            $(".div-element").each( function ( element ){
                let divClasses = $(this).prop("class").replace("hidden ","").replace("col-12 ","").replace("div-element ","").split(" ");
                if ( divClasses.includes( option ) ){
                    $(this).removeClass("hidden");
                }
            });


        }else{
            $("#your-details").addClass("hidden");
            $("#main-step-footer").hide();
        }

        $("#_elev_io .step-footer button span").text( $(this).find("option:selected").data("button-label")  );

        if ( $(this).val() === 'Support (I have a booking)' ){
            $("#your-booking-area").removeClass("hidden");
        }else{
            $("#your-booking-area").addClass("hidden");
        }

        fieldsCheck();

        if ( help_center_el === 'text-us' ){
            let fixedShortCodeMessage = fixShortCode( $(this).find("option:selected").data("text-us-message") ?? '' );
            $(".message_field:visible").val( fixedShortCodeMessage ).trigger("change");
        }
    })

    function fieldsCheck(){
        $(".app-html .form-input-field[required]:visible").keyup();
    }

});

function mainPage(){
    closeHelpCentreSheets();
    $(".categories-outer").children().remove();
    $("#help-center-right-side .loader").show();

    var data = {
        'action': 'help_center',
        'h'     : 'open',
        'a'     : '1',
        'c'     : checkContactRestricted(),
    };
    if ( helpCenterPreviewFlag() ){ data.next = 'yes'; }
    if ( helpCenterOnBookingPage() ){ data.nb = 1; }

    help_center_ajax = jQuery.post(ajaxurl, data, function(response) {
        help_center_page = 'categories';
        $("#load-wrapper").remove();
        $("#help-center-right-side").append( response );
        $("#help-center-right-side .loader").hide();
        $("#main-container").addClass("hideOnMobile");

    });
}

// the open panel's home again, as opening it loads it (onHelpCenterInit): after a sign-in, the signed-in home (COOL 394)
function helpCenterReloadHome(){
    closeHelpCentreSheets();
    $("#load-wrapper").remove();
    $("#help-center-right-side .loader").show();

    var data = {
        'action': 'help_center',
        'h'     : 'open',
        'c'     : checkContactRestricted(),
    };
    if ( helpCenterOnBookingPage() ){ data.nb = 1; }

    help_center_ajax = jQuery.post(ajaxurl, data, function(response) {
        help_center_page = 'categories';
        $("#help-center-right-side").append( response );
        $("#help-center-right-side .loader").hide();
        fixWidth();
    });
}

function changeFormsSizeAccordingToWidth(){

    const fields = $("#_elev_io .custom-input:not(.fixed-input-style), #_elev_io .custom-select:not(.fixed-input-style)");

    if ( fields.length > 0 ){
        if ( document.documentElement.clientWidth > 700 ){
            fields.removeClass("custom-input-sm");
            fields.addClass("custom-input-md");
        }else{
            fields.removeClass("custom-input-md");
            fields.addClass("custom-input-sm");
        }
    }
}

var helpCenterPhoneIdentifier = 'helpCenterPhone';
var helpCenterPhoneIdentifierInc = 1;
function HelpCenterInit(){
    helpCenterPhoneIdentifier = 'helpCenterPhone' + '__' + helpCenterPhoneIdentifierInc;
    helpCenterPhoneIdentifierInc ++;
    fixWidth();
    pageLoad();

    TmPhoneEl.add(document.querySelector('#phone'), helpCenterPhoneIdentifier);
    changeFormsSizeAccordingToWidth();

    setTimeout( function(){
        setVisitorContact();
        $("#how_can_we_help").change();
    }, 200);

    if ( typeof link_color != 'undefined' ){
            jQuery("._elevio_article_body a").addClass(link_color);
    }
}

function setVisitorContact(){
    let visitorInfo = {};
    // signed in: the account's own details first, the visitor cookies for what it lacks (help-center-contact.php; COOL 378)
    const account = typeof help_center_account_contact === 'object' && help_center_account_contact ? help_center_account_contact : {};
    visitorInfo.full_name = account.name || tmVisitorStore.getDetail('name');
    if( visitorInfo.full_name ) {
        visitorInfo.first_name = visitorInfo.full_name.split(" ")[0];
        visitorInfo.last_name = visitorInfo.full_name.split(" ")[1];
        let visitorPhone = account.phone || tmVisitorStore.getDetail('phone');
        let visitorEmail = account.email || tmVisitorStore.getDetail('email');

        if ( visitorPhone ){
            visitorInfo.country_code = visitorPhone.split("(")[0].replace("+","")
            visitorInfo.phone = visitorPhone.split("(")[1];
            if ( visitorPhone.split("(")[1] !== undefined ){
                visitorInfo.phone = visitorInfo.phone.replace(")","").replace("-","").replace(" ","");
            }else{
                visitorInfo.phone = visitorPhone;
            }
            visitorInfo.full_phone = visitorPhone.replace(")","").replace("-","").replace("(","");
            jQuery("span[data-ref='phone']").text( visitorInfo.full_phone );

            let tmPhoneElForHelpCenter = TmPhoneEl.instance(helpCenterPhoneIdentifier);
            if ( tmPhoneElForHelpCenter ){ // Text Us has no phone field
                tmPhoneElForHelpCenter.setNumber(visitorInfo.full_phone);
            }
        }

        if (  visitorEmail ){
            visitorInfo.email = visitorEmail;
        }

        if ( visitorInfo.first_name !== 'Visitor' ){
            $(".app-html #form-first-name").val(visitorInfo.full_name);
            jQuery("span[data-ref='name']").text( visitorInfo.full_name );
        }

        $(".app-html #form-first-name").trigger("change");

        if ( visitorInfo.email ){
            $(".app-html #email_address").val(visitorInfo.email);
            jQuery("span[data-ref='email']").text( visitorInfo.email );
            prefilled_callus = true;
            $(".app-html #email_address").trigger("change");
        }
    }

    // Text Us asks no phone or email (help-center-contact.php), so only the fields it shows count
    const name = $(".app-html #form-first-name").val() ?? '';
    const phone = $(".app-html #phone").length ? $(".app-html #phone").val() : 'n/a';
    const email = $(".app-html #email_address").length ? $(".app-html #email_address").val() : 'n/a';

    if ( name.length === 0 || phone.length === 0 || email.length === 0 ){
        jQuery(".card-details").toggleClass("d-none");
        jQuery(".change-inputs .d-none").toggleClass("d-none");
        jQuery('#form-first-name').focus();
    }

    let latestOrderRef = tmVisitorStore.getLatestOrderRef();
    // signed in with upcoming bookings: one of them (the remembered one, else the soonest), never one the picker doesn't list
    const $pickerOptions = $("[data-hc-booking-picker] .hc-booking-picker__option");
    if ( $pickerOptions.length ){
        latestOrderRef = $pickerOptions.filter(function(){ return $(this).attr("data-ref") === latestOrderRef; }).length ? latestOrderRef : $pickerOptions.first().attr("data-ref");
    }
    let currentVisitorDepartment = 'Sales'
    if ( latestOrderRef !== null ){
        currentVisitorDepartment = 'Support';
        $("#form-booking-id").removeAttr("disabled").val(latestOrderRef).removeClass("empty");
    }
    $("#how_can_we_help").find("option[data-calltype=" + currentVisitorDepartment + "]").prop("selected","selected").change();

}

// The Booking ID's lookup (help-center.php help_center_check_booking_callback_handler()): the footer's Lookup Booking, and
// Talk to us's booking picker directly (hcBookingPickerChoose(), not by relabelling the button and clicking it; review of
// PR #697). callback_btn: the footer's button, which shows the lookup's spinner and its answer
function helpCenterLookupBooking(callback_btn){
    const name = $("#_elev_io #form-first-name").val();
    let tmPhoneElForHelpCenter = TmPhoneEl.instance(helpCenterPhoneIdentifier);
    const phone = tmPhoneElForHelpCenter ? tmPhoneElForHelpCenter.getNumber() : '';
    const email = $("#_elev_io #email_address").val();

    if ( typeof success_page_ajax !== 'undefined' && success_page_ajax !== null ){
        success_page_ajax.abort();
    }
    callback_btn.attr("disabled", true);
    callback_btn.find(".loader").removeClass("hidden").css("display","inline");
    tmVisitorStore.saveDetails(name, phone, email);

    var data = {
        'action': 'help_center_check_booking_callback',
        'calltype': $('#how_can_we_help option:selected').attr('data-calltype'),
        'calltype_description': $('#how_can_we_help').val(),
        'first': name,
        'email': email,
        'phone': phone,
        'booking_id': $("#form-booking-id").val(),
        'l'     :  tmUtils.getAjaxRequestNonce(),
    };

    $(".booking-id-found, .booking-id-not-found").addClass("hidden");


    success_page_ajax = jQuery.post(ajaxurl, data, function(response) {
        $("#form-booking-id").attr("disabled","disabled");
        $(".message-request-element").addClass("hidden");

        const resp = JSON.parse( response );

        if ( resp.error == 1  ){ // order not found, cancelled etc
            if ( resp.error_message == 'Order is old' ){
                $(".booking-actions-el").removeClass("hidden");
                $("#booking_actions .extra-option-my-booking").remove();
                $("#booking_actions .first-select-an-option").after( resp.options );
            }else{
                $(".booking-id-found").removeClass("hidden");
                callback_btn.hide();
            }

            if ( resp.request_box ){
                callback_btn.show();
                callback_btn.attr("disabled", true);
                callback_btn.find(".loader").hide();
                $(".booking-id-not-found > p").html( resp.request_box_message );
                $(".step-footer button span").text("Request a Callback");
                $(".booking-id-not-found").removeClass("hidden");
            }

        }else{ // order found
            $(".booking-id-found, .booking-actions-el").removeClass("hidden");
            $("#booking_actions .extra-option-my-booking").remove();
            $("#booking_actions .first-select-an-option").after( resp.options );
            $(".help-center-contact-btn").removeAttr("disabled");
            callback_btn.hide();
        }

        $("#booking-id-edit-btn").show();
        hcBookingPillsAfterLookup(resp);
        // answered after the visitor switched to another choice (picker form): keep that choice's button
        if ( $("[data-hc-booking-picker]").length && $("#how_can_we_help").val() !== 'Support (I have a booking)' ){
            $(".help-center-contact-btn").show().find(".loader").hide();
            $(".app-html .form-input-field[required]:visible").first().trigger("keyup"); // enabled as its fields say
        }
    });

    details_entered.name = name;
    details_entered.phone_number = phone;
    details_entered.email_address = email;

    $("#booking_actions").val("");
    $("#_elev_io .message_field:visible").val('').addClass("empty");
}

// Talk to us signed in with upcoming bookings (templates/help-center-contact.php; Peter, COOL 379): "Your Booking" is a
// picker of them and "I'd like to" a row of pills. Choosing a booking looks it up as the Booking ID field did (the field
// and its select stay, hidden, so cancel, refund and the callback go on as before); the pills show the choices the lookup
// gave the select and pick them, except Cancel booking ("Plan to rebook?" first) and Change date/time / Add/remove
// tickets where the booking view can change the booking (their links)
function hcBookingPickerChoose(ref){
    const $picker = $("[data-hc-booking-picker]");
    const $option = $picker.find(".hc-booking-picker__option").filter(function(){ return $(this).attr("data-ref") === ref; }).first();
    if ( !$option.length ){
        return;
    }
    $picker.find(".hc-booking-picker__option").attr("aria-selected", "false");
    $option.attr("aria-selected", "true");
    $picker.find(".hc-booking-picker__current").html( $option.find(".hc-booking-picker__row").clone() );
    hcBookingPickerClose();
    hcBookingLinksLoad($option);
    if ( hcPickerFormOnly() ){ // Text Us / Live Chat: the booking only names itself in the SMS, no lookup
        $("#form-booking-id").val(ref);
        hcFormPillsShow();
        return;
    }
    if ( $picker.attr("data-looked-up") === ref ){
        return;
    }
    $picker.attr("data-looked-up", ref);

    $("#form-booking-id").removeAttr("disabled").val(ref).removeClass("empty");
    $(".booking-actions-el, .booking-id-not-found, .booking-id-found").addClass("hidden");
    $("#cancellation-wrapper").empty();
    $("#booking_actions").val("");
    $(".message-request-element").addClass("hidden");
    // the lookup's own button, out of sight while it runs (hcBookingPillsAfterLookup() brings the footer back)
    $("#main-step-footer").addClass("d-none");
    helpCenterLookupBooking( $(".help-center-contact-btn").first().show() );
    hcFormPillsShow();
}

// An upcoming booking's self-serve pages for its pills (help-center.php help_center_booking_links_handler()), asked once
// when it is first picked rather than worked out for every upcoming trip on each open (review of PR #697): its picker row's
// data-change-url / data-tickets-url / data-cancel-url, '' = the pill asks us. Its pills wait (disabled) until they are in,
// so a self-serve pill always opens its page; a past trip's row has its pages already
function hcBookingLinksLoad($option){
    if ( $option.attr("data-past") === "1" || $option.attr("data-links") === "1" ){
        hcFormPillsBusy(false);
        return;
    }
    hcFormPillsBusy(true);
    if ( $option.attr("data-links") === "0" ){
        return; // already asked (the form's first choice comes twice on open)
    }
    $option.attr("data-links", "0");
    jQuery.post(ajaxurl, {
        'action': 'help_center_booking_links',
        'booking_id': String($option.attr("data-ref") || ''),
        'l': tmUtils.getAjaxRequestNonce(),
    }, null, 'json').done(function(links){
        ['change', 'tickets', 'cancel'].forEach(function(key){
            $option.attr("data-" + key + "-url", links && links[key] ? String(links[key]) : '');
        });
    }).always(function(){
        $option.attr("data-links", "1"); // a failed ask leaves no pages: the pills ask us
        if ( hcBookingPickerSelected().is($option) ){
            hcFormPillsBusy(false);
        }
    });
}

// the self-serve pills while the picked booking's pages are on their way (hcBookingLinksLoad()); Something else needs none
function hcFormPillsBusy(busy){
    $("[data-hc-form-pills]").attr("aria-busy", busy ? "true" : "false")
        .find("[data-hc-form-pill]:not([data-hc-form-pill='other'])").prop("disabled", busy);
}

// Text Us / Live Chat signed in (templates/help-center-contact.php $hc_picker_form): the picker without the lookup
function hcPickerFormOnly(){
    return typeof help_center_el !== 'undefined' && ( help_center_el === 'text-us' || help_center_el === 'live-chat' );
}

// Talk to us, Text Us and Live Chat alike (help-center-contact.php data-hc-form-pills, under the booking card; Peter, COOL
// 396): Booking-related shows the picked trip's options (a past one's or an upcoming one's, data-past) and Something else,
// each opening its self-serve page where the booking has one (its picker row's data-*-url); another choice shows none
// (Peter, COOL 385). The button stays out of sight until a pill that needs us is picked (hcFormPillAsk())
function hcFormPillsShow(){
    const $pills = $("[data-hc-form-pills]");
    if ( !$pills.length ){
        return;
    }
    const $booking = hcBookingPickerSelected();
    const forBooking = $("#how_can_we_help").val() === 'Support (I have a booking)' && $booking.length > 0;
    // every option of the trip's kind, linked or not: one with no page yet asks us as Something else does, until it is
    // hooked up (Peter, COOL 396)
    const past = $booking.attr("data-past") === "1";
    const keys = past ? ['review', 'details', 'refund', 'other'] : ['cancel', 'change', 'tickets', 'other'];
    let any = false;
    $pills.find("[data-hc-form-pill]").removeClass("hc-booking-pill--selected").each(function(){
        const key = $(this).attr("data-hc-form-pill");
        const has = forBooking && keys.indexOf(key) !== -1;
        $(this).toggleClass("d-none", !has);
        any = any || has;
    });
    $pills.toggleClass("d-none", !any);
    $("#main-step-footer").toggleClass("d-none", any);
    $(".message-request-element").addClass("hidden");
}

// a pill that needs us: chosen, and the button (Talk to us: the lookup's choice in the hidden select, whose change brings
// up the message box and Request a Callback, as before)
function hcFormPillAsk($pill){
    const key = $pill.attr("data-hc-form-pill");
    $("[data-hc-form-pill]").removeClass("hc-booking-pill--selected");
    $pill.addClass("hc-booking-pill--selected");
    $("#main-step-footer").removeClass("d-none");
    if ( hcPickerFormOnly() ){
        $(".app-html .form-input-field[required]:visible").first().trigger("keyup"); // enabled as its fields say
        return;
    }
    // the lookup's own choice where it gave one, else Something else's
    const value = key === 'change' ? '1' : ( key === 'tickets' ? '2' : ( key === 'refund' ? '5' : '4' ) );
    hcBookingPickAction( $("#booking_actions option[value='" + value + "']").length && value !== '5' ? value : '4' );
}

function hcBookingPickerClose(){
    $(".hc-booking-picker .hc-booking-picker__list").attr("hidden", true);
    $(".hc-booking-picker .hc-booking-picker__field[aria-haspopup]").attr("aria-expanded", "false");
}

// the Activity FAQ's booking picker (templates/categories.php data-hc-faq-picker; Peter, COOL 396): the chosen trip's
// questions show, filtered by what "Filter answers" holds
function hcFaqPickerChoose($picker, ref){
    const $option = $picker.find(".hc-booking-picker__option").filter(function(){ return $(this).attr("data-ref") === ref; }).first();
    if ( !$option.length ){
        return;
    }
    $picker.find(".hc-booking-picker__option").attr("aria-selected", "false");
    $option.attr("aria-selected", "true");
    $picker.find(".hc-booking-picker__current").html( $option.find(".hc-booking-picker__row").clone() );
    hcBookingPickerClose();
    $("[data-hc-faq-for]").each(function(){
        $(this).toggleClass("d-none", $(this).attr("data-hc-faq-for") !== ref);
    });
    $("#hc-all-articles .hc-activity-faq .c-picker-search input").trigger("input");
}

// the lookup has answered (the Lookup Booking click in help-center.js): the choices it put in the hidden select stay there
// for the pills that need us; the button stays away until one is picked, unless the lookup could not help (its message box)
function hcBookingPillsAfterLookup(resp){
    if ( !$("[data-hc-booking-picker]").length ){
        return;
    }
    const found = resp && (resp.error == 0 || resp.error_message == 'Order is old');
    // a pill picked while the lookup was out: its choice again, now the lookup's are in the select (the answer reset them)
    const $picked = $("[data-hc-form-pill].hc-booking-pill--selected");
    if ( found && $picked.length ){
        hcFormPillAsk($picked);
        return;
    }
    $("#main-step-footer").toggleClass("d-none", found && !$("[data-hc-form-pills]").hasClass("d-none"));
}

// "Plan to rebook?" (help-center-contact.php), set up once per Talk to us the panel loads
function hcRebookModal(){
    if ( typeof Modal === 'undefined' || !document.querySelector('#hc-rebook-modal') ){
        return null;
    }
    const modal = Modal.instance('#hc-rebook-modal');
    return modal && modal.modal.isConnected ? modal : Modal.add('#hc-rebook-modal');
}

function hcBookingPickerSelected(){
    return $("[data-hc-booking-picker] .hc-booking-picker__option[aria-selected='true']");
}

// a pill picks its choice in the hidden select, whose change shows the message box and the button as before
function hcBookingPickAction(value){
    $("#booking_actions").val(value).trigger("change");
}

jQuery(function($){
    $(document).on("click", ".hc-booking-picker .hc-booking-picker__field[aria-haspopup]", function(e){
        e.stopPropagation();
        const $list = $(this).siblings(".hc-booking-picker__list");
        const open = $list.is("[hidden]");
        $list.attr("hidden", !open);
        $(this).attr("aria-expanded", open ? "true" : "false");
        // keyboard opens (Enter / Space: detail 0) move focus to the chosen row for the arrow keys; a click or tap leaves it
        // on the field, so no row is filled until hovered (Peter, COOL 385)
        if ( open && e.detail === 0 ){
            $list.find("[aria-selected='true']").trigger("focus");
        }
    });
    $(document).on("click", ".hc-booking-picker .hc-booking-picker__option", function(){
        const $picker = $(this).closest(".hc-booking-picker");
        if ( $picker.is("[data-hc-faq-picker]") ){
            hcFaqPickerChoose($picker, String($(this).attr("data-ref")));
        }else{
            hcBookingPickerChoose( String($(this).attr("data-ref")) );
        }
        $picker.find(".hc-booking-picker__field").trigger("focus");
    });
    $(document).on("keydown", ".hc-booking-picker .hc-booking-picker__option", function(e){
        if ( e.key === "Enter" || e.key === " " ){
            e.preventDefault();
            $(this).trigger("click");
        }else if ( e.key === "ArrowDown" || e.key === "ArrowUp" ){
            e.preventDefault();
            $(this)[e.key === "ArrowDown" ? "next" : "prev"]().trigger("focus");
        }else if ( e.key === "Escape" ){
            hcBookingPickerClose();
            $(this).closest(".hc-booking-picker").find(".hc-booking-picker__field").trigger("focus");
        }
    });
    $(document).on("click", function(e){
        if ( !$(e.target).closest(".hc-booking-picker").length ){
            hcBookingPickerClose();
        }
    });

    // "Support (I have a booking)": the picker's booking, looked up once
    $(document).on("change", "#how_can_we_help", function(){
        const was = $(this).data("hcWas");
        $(this).data("hcWas", $(this).val());
        if ( $(this).val() === 'Support (I have a booking)' && $("[data-hc-booking-picker]").length ){
            if ( was && was !== $(this).val() ){
                // back from another choice, which showed its own button: look the booking up again so the button and
                // the pills are as the lookup leaves them
                $("[data-hc-booking-picker]").removeAttr("data-looked-up");
            }
            const ref = String($("#form-booking-id").val() || '');
            hcBookingPickerChoose( $("[data-hc-booking-picker] .hc-booking-picker__option[data-ref='" + ref.replace(/'/g, '') + "']").length ? ref : String($("[data-hc-booking-picker] .hc-booking-picker__option").first().attr("data-ref")) );
        }else if ( $("[data-hc-booking-picker]").length && $(this).val() !== '' && !hcPickerFormOnly() ){
            // Something else after the preselected Booking-related: a found booking's lookup hides the button (its
            // pills replace it) and the footer while it runs, so this choice's own button never showed (Peter, COOL 385)
            $("#main-step-footer").removeClass("d-none");
            $(".help-center-contact-btn").show().find(".loader").hide(); // the lookup's spinner, left on when it hid the button
        }
        hcFormPillsShow();
        // Text Us / Live Chat: the button is ready once no field it shows is empty (Live Chat's form may show none)
        if ( hcPickerFormOnly() && $("[data-hc-booking-picker]").length && $(this).val() !== '' ){
            const emptyField = $(".app-html .form-input-field[required]:visible").filter(function(){ return $(this).val() === ''; }).length;
            $(".help-center-contact-btn").prop("disabled", emptyField > 0);
        }
    });

    // Live Chat's form (Peter, COOL 383): Start Chatting closes the panel and opens the chat, as the link did
    $(document).on("click", "#live-chat-btn:contains('Start Chatting')", function(){
        $(".help-center-tint").first().trigger("click");
        coolEvents.triggerChatOpen();
    });

    // the signed-out home's Log in (templates/categories.php; modal.js has opened the login modal). Desktop: the login is
    // one of the panel's bottom sheets (modal.scss #help-center-right-side .c-auth-modal-wrapper), the help centre
    // stays, and once signed in it reloads on the signed-in home (Peter, COOL 394). Phones: the modal opens under the
    // panel's tint, so the panel closes first, as Start Chatting's does (Peter, COOL 393)
    $(document).on("click", "#help-center-right-side [data-modal-target='#c-auth-modal']", function(){
        if ( window.innerWidth <= 1025 ){
            $(".help-center-tint").first().trigger("click");
            return;
        }
        const authModal = document.getElementById("c-auth-modal");
        if ( !authModal ){
            return;
        }
        if ( !help_center_auth_modal_home ){
            help_center_auth_modal_home = document.createComment("c-auth-modal");
            authModal.before(help_center_auth_modal_home);
        }
        document.getElementById("help-center-right-side").appendChild(authModal);
        help_center_login_reload = true;
    });

    // the login sheet closed (its X, the panel's tint, Esc, or signed in): back to its place in the page once it has slid out
    // (modal.js close), so the header's Log in opens it as before
    $(document).on("tmModal_closed_#c-auth-modal", function(){
        setTimeout(function(){
            const authModal = document.getElementById("c-auth-modal");
            if ( !tmAuth.isUserLoggedInToCurrentBlog() ){
                help_center_login_reload = false; // closed without signing in: a later sign-in elsewhere leaves the panel be
            }
            if ( help_center_auth_modal_home && authModal && !authModal.classList.contains("open") && authModal.closest("#help-center-right-side") ){
                help_center_auth_modal_home.after(authModal);
            }
        }, 600);
    });

    // signed in from the panel's Log in (any of the login's ways, tm-auth.js): the open help centre reloads on its home
    $(document).on("tmBlogUserLoginStatusChanged", function(){
        if ( !help_center_login_reload || !tmAuth.isUserLoggedInToCurrentBlog() ){
            return;
        }
        help_center_login_reload = false;
        tmAuth.authModalHide();
        if ( $("#help-center-right-side").hasClass("open") ){
            helpCenterReloadHome();
        }
    });

    // a self-serve pill opens its page in a new window, the help centre stays (Peter, COOL 382); Cancel booking asks "Plan to
    // rebook?" first where Talk to us has it; the others need us (hcFormPillAsk())
    $(document).on("click", "[data-hc-form-pill]", function(){
        const key = $(this).attr("data-hc-form-pill");
        if ( key === 'cancel' ){
            const modal = hcRebookModal();
            if ( modal ){
                modal.open();
                return;
            }
        }
        const url = key === 'other' ? '' : String(hcBookingPickerSelected().attr("data-" + key + "-url") || '');
        if ( url !== '' ){
            window.open(url, '_blank', 'noopener');
            return;
        }
        hcFormPillAsk($(this));
    });

    // Plan to rebook?: Cancel booking = the cancellation as before (Start Cancellation, which asks for the booking's
    // cancel page); Reschedule booking = Change date/time, its page in a new window as the pill's (the help centre stays)
    $(document).on("click", "[data-hc-rebook]", function(){
        const modal = hcRebookModal();
        if ( modal ){
            modal.close();
        }
        if ( $(this).attr("data-hc-rebook") === "cancel" ){
            const cancelUrl = String(hcBookingPickerSelected().attr("data-cancel-url") || '');
            if ( cancelUrl !== '' ){
                window.open(cancelUrl, '_blank', 'noopener');
            }else if ( !$("#booking_actions option[value='3']").length ){
                hcFormPillAsk($("[data-hc-form-pill='cancel']"));
            }else{
                hcBookingPickAction("3");
                $(".help-center-contact-btn").removeAttr("disabled").trigger("click");
            }
        }else{
            const changeUrl = String(hcBookingPickerSelected().attr("data-change-url") || '');
            if ( changeUrl !== '' ){
                window.open(changeUrl, '_blank', 'noopener');
            }else{
                hcFormPillAsk($("[data-hc-form-pill='change']"));
            }
        }
    });
});

// Closes the sheets open over the panel (the next trip's Local support, components/modal), as
// their X does, so the page's scroll lock goes with them
function closeHelpCentreSheets(){
    document.querySelectorAll("#help-center-right-side .c-modal-portal.open").forEach(function(portal){
        const sheet = typeof Modal !== 'undefined' && portal.id ? Modal.instance('#' + portal.id) : null;
        if ( sheet ){
            sheet.close();
        }else{
            portal.classList.remove("open");
        }
    });
}

// /account/bookings/ (and its cancel / refund pages) and /booking/… (a booking's view, confirmation, review): the page is
// already about the visitor's bookings, so the help centre opens on its regular list (Peter, COOL 376)
function helpCenterOnBookingPage(){
    return /^\/(account\/bookings|booking)(\/|$)/.test(window.location.pathname);
}

function checkContactRestricted(){
    return typeof Cookies.get('tm-contact-restricted') !== 'undefined' ? true : false;
}

// true when the page URL carries ?next, the preview flag (the parameter itself, as PHP's isset): the panel's admin-ajax
// request then posts next=yes, which help_center() reads back, and Talk to us previews the Desk form (COOL 258). Without it
// the key is not posted at all: widget/functions.php switches ASSETS_FILE_VERSION on the key's presence
function helpCenterPreviewFlag(){
    return new URLSearchParams(window.location.search).has('next');
}

function removeContactTopLinksAndReplace(){
    $("li.sms_info ,li.sms_info + li").remove();
    $(".contact_info .underline-hover").text('We will reach out to you soon.');
    $(".contact_info .underline-hover").parent().addClass("removeLink");
    $(".contact_info a").removeClass("help-center-link");

    if ( $(".talk-to-us-area").length > 0 ){
        $(".talk-to-us-area a").removeClass("help-center-link").addClass("removeLink").text('We received your callback request and will reach out soon (support hours 8am-11pm EST).');
    }

    if ( $(".text-message-area").length > 0 ){
        $(".text-message-area").remove();
    }

    if ( $(".live-chat-area").length > 0 ){
        $(".live-chat-area").remove();
    }

    if ( $(".here-to-help-section").length > 0 ){
        var str = $('.here-to-help-section p').html().replace(/We’re here to help. /g, '');
        $('.here-to-help-section p').html(str);

        $(".here-to-help-section em").text('We have received your callback request and will reach out soon (support hours 8am-11pm EST).');
    }
}
